import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-Vector",
  "use": "icon-Vector-usage",
  "viewBox": "0 0 9.5 9.5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 9.5 9.5\" id=\"icon-Vector\"><g><path d=\"M1,0C0.447715,0,0,0.447715,0,1C0,1,0,8.5,0,8.5C0,9.05227,0.447715,9.5,1,9.5C1,9.5,8.5,9.5,8.5,9.5C9.05227,9.5,9.5,9.05227,9.5,8.5C9.5,8.5,9.5,1,9.5,1C9.5,0.447715,9.05227,0,8.5,0C8.5,0,1,0,1,0C1,0,1,0,1,0ZM1,1C1,1,8.5,1,8.5,1C8.5,1,8.5,8.5,8.5,8.5C8.5,8.5,1,8.5,1,8.5C1,8.5,1,1,1,1C1,1,1,1,1,1ZM3.5,2C3.5,2,2,2,2,2C2,2,2,3.5,2,3.5C2,3.5,3.5,3.5,3.5,3.5C3.5,3.5,3.5,2,3.5,2C3.5,2,3.5,2,3.5,2ZM7.5,7.5C7.5,7.5,7.5,3.5429,7.5,3.5429C7.5,3.5429,4.79695,6.24595,4.79695,6.24595C4.79695,6.24595,3.875,5.0606,3.875,5.0606C3.875,5.0606,1.97768,7.5,1.97768,7.5C1.97768,7.5,7.5,7.5,7.5,7.5C7.5,7.5,7.5,7.5,7.5,7.5Z\" fill-rule=\"evenodd\" fill=\"#86909C\" fill-opacity=\"1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/Vector.svg
// module id = 3BqK
// module chunks = 119